// extracted by mini-css-extract-plugin
module.exports = {"panelSeparator":"HomePosts_panelSeparator__2ZyNR","posts":"HomePosts_posts__9jZvY","postsContent":"HomePosts_postsContent__eFZkI","postsAction":"HomePosts_postsAction__OlZ1M"};